import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeleteParametroSistema() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteParametroSistema = useCallback(
        (sistemaId: string, id: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/sistema/${sistemaId}/parametro/${id}`,
                method: 'DELETE',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deleteParametroSistema,
    };
}
